import { ModalContext } from 'app/app';
import axios from 'axios';
import { FieldInput } from 'components/fieldInput';
import { AuthContext, Icon, ViewContext } from 'components/lib';
import { Form, Formik } from 'formik';
import InputUtils from 'helpers/inputUtils';
import { Fragment, useContext, useEffect, useState } from 'react';
import * as Yup from 'yup';
import image from './images/loader.gif';
import styles from './styles.module.scss';

export function CompanyModal(props) {
  const context = useContext(ViewContext);
  const { modal, setModal } = useContext(ModalContext);
  const Auth = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [checkBox, setCheckBox] = useState(false);
  const [phone, setPhone] = useState('');

  const inputUtils = new InputUtils();

  const firstValidationSchema = Yup.object().shape({
    dot_number: Yup.string().required(
      'The field "DOT Number" is required!'
    ),
  });

  const secondValidationSchema = Yup.object().shape({
    company_name: Yup.string().required('This field is required!'),
    dba_name: Yup.string(),
    owner_name: Yup.string().required('This field is required!'),
    phone: Yup.string()
      .required('This field is required!')
      .min(14, 'Number format invallid.'),
    email: Yup.string()
      .email('Invalid email!')
      .required('This field is required!'),
  });

  const handleChangePhoneNumber = (event, handleChange) => {
    handleChange(event);
    setPhone(inputUtils.number(event.target.value, phone));
  };

  useEffect(() => {
    setCheckBox(false);
  }, [modal]);

  return (
    <Fragment>
      {modal.name === 'company_modal' && modal.stage === 1 && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>Add Company</div>
              <div className={styles.line} />
              <Formik
                validationSchema={
                  checkBox ? null : firstValidationSchema
                }
                initialValues={{
                  dot_number: '',
                }}
                onSubmit={async (values) => {
                  if (values.dot_number) {
                    /*        const company_data = await axios.get(
                      "/api/company/info/" + values.dot_number
                    ); */

                    setModal({
                      name: 'company_modal',
                      stage: 2,
                      data: {
                        dot_number:
                          values.dot_number === ''
                            ? null
                            : values.dot_number,
                        /*        company_name: company_data.data.data.content
                          ? company_data.data.data.content.carrier.legalName
                          : "",
                        city:
                          company_data.data.data.content &&
                          company_data.data.data.content.carrier.phyCity
                            ? company_data.data.data.content.carrier.phyCity
                            : "",
                        country:
                          company_data.data.data.content &&
                          company_data.data.data.content.carrier.phyCountry
                            ? company_data.data.data.content.carrier.phyCountry
                            : "",
                        state:
                          company_data.data.data.content &&
                          company_data.data.data.content.carrier.phyState
                            ? stateOptions.find(
                                (item) =>
                                  item.label ===
                                  company_data.data.data.content.carrier
                                    .phyState
                              ).value
                            : "",
                        address:
                          company_data.data.data.content &&
                          company_data.data.data.content.carrier.phyStreet
                            ? company_data.data.data.content.carrier.phyStreet
                            : "",
                        zip:
                          company_data.data.data.content &&
                          company_data.data.data.content.carrier.phyZipcode
                            ? company_data.data.data.content.carrier.phyZipcode
                            : "", */
                      },
                      action: modal.action,
                    });
                  } else {
                    setModal({
                      name: 'company_modal',
                      stage: 2,
                      data: {
                        dot_number:
                          values.dot_number === ''
                            ? null
                            : values.dot_number,
                      },
                      action: modal.action,
                    });
                  }
                }}
              >
                {({
                  errors,
                  touched,
                  values,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  submitForm,
                }) => (
                  <Fragment>
                    <Form
                      className={styles.form}
                      onSubmit={handleSubmit}
                    >
                      <div
                        className={styles.fieldRow}
                        style={{ paddingBottom: 0, height: 100 }}
                      >
                        <FieldInput
                          id="dot_number"
                          type="text"
                          label="DOT Number"
                          placeholder="DOT Number"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          disabled={checkBox}
                        />
                      </div>
                      <div className={styles.checkboxContainer}>
                        <input
                          type="checkbox"
                          onChange={() => {
                            setCheckBox(!checkBox);
                            values.dot_number = '';
                          }}
                        />
                        <span>No DOT Number</span>
                      </div>
                    </Form>
                    <div
                      className={styles.footer}
                      style={
                        errors.dot_number && !checkBox
                          ? { justifyContent: 'space-between' }
                          : {}
                      }
                    >
                      {errors.dot_number && !checkBox && (
                        <div className={styles.errorMessage}>
                          <div className={styles.icon}>
                            <Icon image="alert-circle" />
                          </div>
                          <span>{errors.dot_number}</span>
                        </div>
                      )}
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => setModal('')}
                        >
                          Cancel
                        </button>
                        <button
                          className={styles.save}
                          onClick={submitForm}
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </Fragment>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}

      {modal.name === 'company_modal' && modal.stage === 2 && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>Add/Edit Company</div>
              <div className={styles.line} />
              <Formik
                validationSchema={secondValidationSchema}
                initialValues={{
                  dot_number: modal.data.dot_number,
                  company_name: modal.data.company_name
                    ? modal.data.company_name
                    : '',
                  dba_name: '',
                  owner_name: '',
                  phone,
                  email: '',
                  status: '',
                }}
                onSubmit={async (values) => {
                  if (loading) return;

                  setLoading(true);

                  await axios
                    .post(`/api/company`, {
                      dot_number: values.dot_number,
                      name: values.company_name.trim(),
                      dba_name: values.dba_name,
                      owner_name: values.owner_name,
                      phone: values.phone,
                      email: values.email,
                      premium: 0,
                      status: 'lead',
                      account_id: Auth.user.account_id,
                      address: modal.data.address
                        ? modal.data.address
                        : '',
                      city: modal.data.city ? modal.data.city : '',
                      state: modal.data.state ? modal.data.state : '',
                      zip: modal.data.zip ? modal.data.zip : '',
                    })
                    .then((res) => {
                      setLoading(false);
                      setModal({});

                      context.notification.show(
                        'Company created successfully!',
                        'success',
                        true,
                        'toast',
                        'check-circle'
                      );

                      modal.action();
                    })
                    .catch((err) => {
                      setLoading(false);
                      setModal({});

                      context.notification.show(
                        err.response.data.message,
                        'error',
                        true,
                        'toast',
                        'x-circle'
                      );
                    });
                }}
              >
                {({
                  errors,
                  touched,
                  values,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  submitForm,
                }) => (
                  <Fragment>
                    <Form
                      className={styles.form}
                      onSubmit={handleSubmit}
                    >
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="company_name"
                          type="text"
                          label="Company Name"
                          placeholder="Company Name"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.company_name}
                          touched={touched.company_name}
                          required
                        />
                        <FieldInput
                          id="dba_name"
                          type="text"
                          label="DBA Name"
                          placeholder="DBA Name"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.dba_name}
                          touched={touched.dba_name}
                        />
                      </div>
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="owner_name"
                          type="text"
                          label="Owner Name"
                          placeholder="Owner Name"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.owner_name}
                          touched={touched.owner_name}
                          required
                        />
                        <FieldInput
                          id="phone"
                          type="phone"
                          label="Phone"
                          placeholder="Phone"
                          handleChange={(event) => {
                            handleChangePhoneNumber(
                              event,
                              handleChange
                            );
                          }}
                          value={phone}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.phone}
                          touched={touched.phone}
                          required
                        />
                      </div>
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="email"
                          type="text"
                          label="Email"
                          placeholder="Email"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.email}
                          touched={touched.email}
                          halfSize
                          required
                        />
                        {/*      {modal.data.company_name && (
                          <div className={styles.field}>
                            <label>
                              Status <span>*</span>
                            </label>
                            <select
                              id="status"
                              name="status"
                              className={styles.inputDropdown}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            >
                              <option value="active" label="active" />
                            </select>
                          </div>
                        )} */}
                      </div>
                    </Form>
                    <div className={styles.footer}>
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => setModal('')}
                        >
                          Cancel
                        </button>
                        <button
                          className={styles.save}
                          onClick={submitForm}
                        >
                          {loading ? (
                            <img
                              src={image}
                              alt="loading"
                              style={{ width: '25px' }}
                            />
                          ) : (
                            'Save'
                          )}
                        </button>
                      </div>
                    </div>
                  </Fragment>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
